import { ReactElement } from 'react';

import { Translate } from '@dreryk/react-common';
import {
   appendTestableComponentAttributes,
   IconFillColor,
   IconSize,
   IconWrapper,
   TestableComponentProps,
} from '@dreryk/react-components';

import { StyledModuleChip } from './ModuleChip.styled';

type ModuleChipProps = {
   readonly icon: ReactElement;
   readonly label: string;
} & TestableComponentProps;

export const ModuleChip = (props: ModuleChipProps): ReactElement => {
   const { icon: Icon, testId, label } = props;

   return (
      <StyledModuleChip gap={4} {...appendTestableComponentAttributes('ModuleChip', testId)}>
         <IconWrapper size={IconSize.NORMAL} testId={props.testId} fillColor={IconFillColor.WHITE}>
            {Icon}
         </IconWrapper>
         <Translate>{label}</Translate>
      </StyledModuleChip>
   );
};
